export const claimsDashboard = {
    noClaimsForUser: "Claim(s) are not found for this user",
    noClaimsForAdminUser: "DataLakeResponse - Claims does not exists for supplied criteria",
};

export const API_ERR_MSG =
  "Sorry something went wrong, please try again later.";
